import type { LoginResponse } from '@api/types/auth'

export const STAFF_MFA_REQUIRED_MESSAGE =
  'Admin access needs two-factor sign-in. Turn on MFA under Settings > Sign-in & security in the app, then sign in again here with your code.'

export const NOT_ADMIN_MESSAGE = 'This site is for admins only. Your account does not have admin access.'

/**
 * Why a signed-in response may not enter the portal, or null when it may. The portal is Admin-only.
 * A staff account that skipped two-factor gets an ordinary-user session (no staff roles) and the
 * server flags it with `staffMfaRequired`, so that case gets its own message rather than "not admin".
 */
export function portalAccessDenial(response: Pick<LoginResponse, 'staffMfaRequired' | 'user'>): string | null {
  if (response.staffMfaRequired || response.user?.staffMfaRequired) return STAFF_MFA_REQUIRED_MESSAGE
  if (!response.user?.roles?.includes('Admin')) return NOT_ADMIN_MESSAGE
  return null
}
